import React, { useState } from "react";
import "./Card.css";
import moment from "moment";
import { FaUser } from "react-icons/fa";
import { FaPhoneAlt } from "react-icons/fa";
import { FcTwoSmartphones } from "react-icons/fc";
import { RiHomeHeartFill } from "react-icons/ri";
import { CgCalendarDates } from "react-icons/cg";
import { FaCalendarCheck } from "react-icons/fa";
import { MdStars } from "react-icons/md";
import { FaMapMarkerAlt } from "react-icons/fa";
import { extractLatLong } from "../Helpers";
import { MdOutlineEventAvailable } from "react-icons/md";
import { MdNotInterested } from "react-icons/md";
import {saveComment} from "./services";
import { FaBowlFood } from "react-icons/fa6";

const Card = ({
  data,
  type,
  handleChefLocation,
  handleChefNewMenu,
  handleChefStatus,
  handleShowMenu,
  handleUnVerifyChef,
  handleVerifyChef,
  handleProfileUpdate,
  handleChefImage,
  handleChefDesc,
  handleKitchenImages,
  handleEmiStatus,
  handlePerformance,
  handleMenuCount,
  handleCraverNotifications,
  showActive,
  handleInitiateChefChat
}) => {
  const [showCard, setShowCard] = useState("");
  const [showCommentBox, setShowCommentBox] = useState("");
  let comments;
  let latLong;
  if (data.userAddress && data.userAddress.coordinates) {
    latLong = extractLatLong(data.userAddress.coordinates);
  }

  const handleStatus = (status) => {
    setShowCard(status);
  };

  const handleComment = () => {
    setShowCommentBox("commentUpdate");
  };


  const RenderShowCard = ({ showCard }) => {
    return (
      <div>
        <input
          className="form-control"
          type="text"
          defaultValue={data.comments}
          value={comments}
          onChange={(e) => {
           comments = e.target.value;
          }}
        />
        <button
          type="button"
          className="btn btn-dark btn-sm mt-1"
          onClick={() => {
            if(showCard == "commentUpdate"){
              setShowCommentBox("")
              saveComment(comments, data);
            } else {
              handleChefStatus(showCard, comments, data);
            }
          }}
        >
          Save Chef Status
        </button>
      </div>
    );
  };

  return (
    <div className="col-xs-12 col-sm-6 col-md-4 col-lg-3 chefCard">
      <div className="cardTitleContainer">
        <p className="titleText">Chef Basic Details</p>
      </div>
      <div className="rowDisplay">
        <p>#{data.userID}</p>
        <a href={"tel:" + data.userMobile} rel="noreferrer">
          <FaPhoneAlt size={16} color="#49243E" /> {data.userMobile}
        </a>
      </div>
      <div className="rowDisplay">
        <p>
        Pure Veg: {"\t"}
          {data.isVeg ? "Yes" : "No"}
        </p>
        {data.FSSAINumberFlag ?
        <p>
        FSSAI: {"\t"}
        {data.FSSAINumber}
      </p> : null}
      </div>
      <div className="rowDisplay">
        <p>
          Serves Bulk: {"\t"}
          {data.servesBulk ? "Yes" : "No"}
        </p>
        {data.chefAlternateNumber ?
        <a href={"tel:" + data.chefAlternateNumber} rel="noreferrer">
          <FcTwoSmartphones size={20} color="#49243E" /> {data.chefAlternateNumber}
        </a> : null}
      </div>
      <div className="rowDisplay">
        <p>
          <FaUser size={18} color="#EF9A53" /> {data.userName}
        </p>
        <p>
          <RiHomeHeartFill size={22} color="#1C3879" /> {data.userKitchen}
        </p>
      </div>
       {data.podName ? <div className="rowDisplay">
        <p>
          <FaMapMarkerAlt size={18} color="#EF9A53" />POD Location -  {data.podName}
        </p>
      </div> : null}
      <div className="rowDisplay">
        <p>
        <FaBowlFood size={18} color="green"/> {data?.kitchenStyle?.toUpperCase() === "BOTH" ? "North/South" : data.kitchenStyle }
        </p>
        {data.isUserAvailable ?
      <p>
        <MdOutlineEventAvailable size={22} color="green" />{" "}
         Available
      </p> :
      <p>
        <MdNotInterested size={22} color="red" />{" "}
         Not Available
      </p>}
      </div>
     
      {type?.toUpperCase() !== "REMOVED" && (
        <>
          <div className="rowDisplay">
            <p>
              <CgCalendarDates size={22} color="#1C3879" />{" "}
              {moment(data.creationDate).format("YYYY-MM-DD")}
            </p>
            <p>
              <MdStars size={22} color="#F3CA52" /> {type?.toUpperCase() !== "VERIFIED" ? data.priorityScore : parseFloat(data.avgRating).toFixed(1)}
            </p>
            {type?.toUpperCase() === "VERIFIED" && (
              <p>
                <FaCalendarCheck size={18} color="green" />{" "}
                {moment(data.verifiedTimestamp).format("YYYY-MM-DD")}
              </p>
            )}
          </div>
          {latLong && latLong.latitude && latLong.longitude && (
            <p>
              <a
                href={`http://maps.google.com/?q=${latLong.latitude},${latLong.longitude}`}
                rel="noreferrer"
                target="_blank"
              >
                <FaMapMarkerAlt size={16} color="#404258" />{" "}
                {data.userAddress.address}
              </a>
            </p>
          )}
        </>
      )}
      <div className="rowDisplayWrapButtons">
        {type?.toUpperCase() !== "VERIFIED" ? (
          <>
            <button
              className="btn btn-info btn-text btn-sm"
              onClick={() => handleChefNewMenu(data)}
            >
              Registered Menu
            </button>
            <button
              className="btn btn-success btn-text btn-sm"
              onClick={() => handleVerifyChef(data)}
            >
              Verify Chef
            </button>
          </>
        ) : (
          <>
          <button
              className="btn btn-info btn-text btn-sm"
              onClick={() => handleChefLocation(data)}
            >
              Update Chef Location
            </button>
          <button
              className="btn btn-info btn-text btn-sm"
              onClick={() => handleChefNewMenu(data)}
            >
              Registered Menu
            </button>
            <button
              className="btn btn-primary btn-text btn-sm"
              onClick={() => handleShowMenu(data)}
            >
              Verified Menu
            </button>
            <button
              className="btn btn-danger btn-text btn-sm"
              onClick={() => handleUnVerifyChef(data)}
            >
              UnVerify
            </button>
            <button
              className="btn btn-success btn-text btn-sm"
              onClick={() => handleEmiStatus(data)}
            >
              Show Emi Status
            </button>
            <button
              className="btn btn-warning btn-text btn-sm"
              onClick={() => handleProfileUpdate(data)}
            >
              Update Profile Image
            </button>
            <button
              className="btn btn-warning btn-text btn-sm"
              onClick={() => handleChefImage(data)}
            >
              Update Chef Image
            </button>
            <button
              className="btn btn-warning btn-text btn-sm"
              onClick={() => handleChefDesc(data)}
            >
              Update Chef Desc
            </button>
            <button
              className="btn btn-warning btn-text btn-sm"
              onClick={() => handleKitchenImages(data)}
            >
              Update kitchen Images
            </button>
            <button
              className="btn btn-primary btn-text btn-sm"
              onClick={() => handlePerformance(data, showActive)}
            >
              Chef Performance
            </button>
            <button
              className="btn btn-primary btn-text btn-sm"
              onClick={() => handleMenuCount(data, showActive)}
            >
              Menu Count
            </button>
            <button
              className="btn btn-primary btn-text btn-sm"
              onClick={() => handleCraverNotifications(data)}
            >
              Send New Chef Alert
            </button>
          </>
        )}
         {type?.toUpperCase() !== "VERIFIED" &&
        type?.toUpperCase() !== "REMOVED" ? (
          <button
            className="btn btn-danger btn-text btn-sm"
            onClick={() => handleUnVerifyChef(data)}
          >
            UnVerify
          </button>
        ) : null}
        {type?.toUpperCase() !== "VERIFIED" && (
          <>
            <button
              type="button"
              className="btn status-btn btn-info btn-sm dropdown-toggle"
              data-toggle="dropdown"
              aria-expanded="false"
            >
              {type?.toUpperCase() === "VERIFIED"
                ? "Verified"
                : showCard || data.chefStatus || "Add Status"}
            </button>
            <div className="dropdown-menu">
            <li
                className="dropdown-item"
                onClick={() => handleStatus("Registered")}
              >
                Registered
              </li>
              <li
                className="dropdown-item"
                onClick={() => handleStatus("Contacted")}
              >
                Contacted
              </li>
              <li
                className="dropdown-item"
                onClick={() => handleStatus("Training")}
              >
                Training
              </li>
              <li
                className="dropdown-item"
                onClick={() => handleStatus("Menu/Catalog")}
              >
                Menu/Catalog
              </li>
              <li
                className="dropdown-item"
                onClick={() => handleStatus("Audit/Sample")}
              >
                Audit/Sample
              </li>
            </div>
            {showCard && <RenderShowCard showCard={showCard} />}
          </>
        )}
         <button
            className="btn btn-success btn-text btn-sm"
            onClick={() => handleInitiateChefChat(data)}
          >
            Intiate chef chat
          </button>
            <p>
              <strong>Comments</strong>: {data.comments || "No Comments"}
            </p>
        <button
          type="button"
          className="btn btn-dark btn-sm mt-1"
          onClick={() => {
            handleComment();
          }}
        >Edit Comments</button>
            {showCommentBox && <RenderShowCard showCard={showCommentBox}  />}
      </div>
    </div>
  );
};

export default Card;
